var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding"},[_c('h2',[_vm._v("404")]),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("Go home")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82417ea0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/Error404.vue
// module id = 828
// module chunks = 10